var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"animation":"slide-up 0.5s ease"}},[_c('services')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }